import { INote } from "../../../../../common/types";

export const getRealLength = (note: INote) => (4 / note.l) * (note.d ? 1.5 : 1);
